import * as actions from '../actions/appActions';

const initialState = {
  isPreloaderVisible: false,
  isMenuVisible: false,
  newBets: false,
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case actions.SHOW_PRELOADER:
    case actions.HIDE_PRELOADER: {
      return {
        ...state,
        isPreloaderVisible: action.type === actions.SHOW_PRELOADER,
      };
    }
    case actions.SHOW_MENU:
    case actions.HIDE_MENU: {
      return {
        ...state,
        isMenuVisible: action.type === actions.SHOW_MENU,
      };
    }
    case actions.SET_NEW_BETS_FLAG: {
      return {
        ...state,
        newBets: action.value,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/app.js